import { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import useRegisteredEvents from './useRegisteredEvents';

const useIsRegisteredForEvent = eventCode => {
    const [isRegistered, setIsRegistered] = useState(false);
    const { registeredEvents } = useRegisteredEvents(false);

    useEffect(() => {
        if (!eventCode) return false;
        if (!registeredEvents) return false;

        if (registeredEvents.map(event => event.code).includes(eventCode)) setIsRegistered(true);
    }, [eventCode, registeredEvents]);

    return { isRegistered };
};

useIsRegisteredForEvent.propTypes = {
    eventCode: PropTypes.string,
};

export default useIsRegisteredForEvent;
